
<button mat-button class="link-button" (click)="onClicked('AddToContact')" *ngIf="!item.cells[fieldDefinition.key].value">
  Add Contact
</button>
<div *ngIf="item.cells[fieldDefinition.key].value" [ngStyle]="getRequestCellStyle()">
  {{item.cells[fieldDefinition.key] && item.cells[fieldDefinition.key].value  !='NoEmail' ? item.cells[fieldDefinition.key].displayText : ''}}
</div>
